import React from "react";

const InnerHeading = ({ Icon, heading, buttonLabel, onClick }) => {
  return (
    <div className="flex_center_span2_space_between align-center">
      <div className="icon_h1">
        <div>
          <Icon></Icon>
        </div>
        <h1>{heading}</h1>
      </div>
      {buttonLabel && <button onClick={onClick}>{buttonLabel}</button>}
    </div>
  );
};

export default InnerHeading;
